import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import {
  GET_COURSE_AND_GRADES_SELECT_LIST,
  GET_COURSE_SELECT_LIST,
  GET_COURSE_SELECT_LIST_LOCAL,
  GetCourseAndGradesSelectListAction,
  GetCourseSelectListAction,
  GetCourseSelectListLocalAction,
} from "./actionTypes";
import {
  getCourseAndGradesSelectListError,
  getCourseAndGradesSelectListSuccess,
  getCourseSelectListError,
  getCourseSelectListLocalError,
  getCourseSelectListLocalSuccess,
  getCourseSelectListSuccess,
} from "./actions";
import {
  getCourseSelectList,
  getCourseAndGradesSelectList,
} from "../../helpers/backend_helper";

function* getCourseSelectListSaga({}: GetCourseSelectListAction) {
  try {
    const response: ResponseGenerator = yield call(getCourseSelectList);
    yield put(getCourseSelectListSuccess(response.data));
  } catch (error) {
    yield put(getCourseSelectListError(error));
  }
}

function* getCourseAndGradesSelectListSaga({}: GetCourseAndGradesSelectListAction) {
  try {
    const response: ResponseGenerator = yield call(
      getCourseAndGradesSelectList
    );
    yield put(getCourseAndGradesSelectListSuccess(response.data));
  } catch (error) {
    yield put(getCourseAndGradesSelectListError(error));
  }
}

function* getCourseSelectListLocal({}: GetCourseSelectListLocalAction) {
  try {
    const response: ResponseGenerator = yield call(getCourseSelectList);
    yield put(getCourseSelectListLocalSuccess(response.data));
  } catch (error) {
    yield put(getCourseSelectListLocalError(error));
  }
}

function* CourseSage() {
  yield takeEvery(GET_COURSE_SELECT_LIST, getCourseSelectListSaga);
  yield takeEvery(
    GET_COURSE_AND_GRADES_SELECT_LIST,
    getCourseAndGradesSelectListSaga
  );
  yield takeEvery(GET_COURSE_SELECT_LIST_LOCAL, getCourseSelectListLocal);
}

export default CourseSage;
